<template>
  <div class="moles__container">
    <Moles :class="color"></Moles>
    <slot></slot>
  </div>
</template>

<script>
import Moles from '@/funnels/components/layout/Moles';

export default {
  components: { Moles },
  props: {
    color: {
      type: String,
    },
  },
};
</script>
